function useMyTeamWorkingInformation() {
  return {};
}

export default useMyTeamWorkingInformation;
